import { httpMain } from "utils/httpRequest/http";

export const uploadAuctionImage = (auctionId, auctionImage) => {
  let formData = new FormData();
  formData.append("auctionImage", auctionImage);
  return httpMain.post(`/auctions/${auctionId}`, formData);
};
